module.exports = __webpack_public_path__ + "img/past-estimates.3679ba25.svg";